var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-head-container" }, [
    _c("div", { staticClass: "page-head clearfix" }, [
      _c("div", { staticClass: "page-head-info columns clearfix" }, [
        _c("div", { staticClass: "nav-bar" }, [
          _c(
            "a",
            {
              on: {
                click: function ($event) {
                  return _vm.navBack()
                },
              },
            },
            [_vm._v("\n          < " + _vm._s(_vm.$t("back")))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-head-project-info clearfix" }, [
          _vm.number
            ? _c("div", { staticClass: "page-project-number" }, [
                _vm._v(
                  " " + _vm._s(_vm.numberType) + " " + _vm._s(_vm.number || "")
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row page-project-name" }, [
            _c("div", [_vm._v(_vm._s(_vm.description))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "float-right clearfix" },
          [_vm._t("default")],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }